import { render } from "./BecomeSellerA.vue?vue&type=template&id=9dc9b764&scoped=true"
import script from "./BecomeSellerA.vue?vue&type=script&lang=js"
export * from "./BecomeSellerA.vue?vue&type=script&lang=js"

import "./BecomeSellerA.vue?vue&type=style&index=0&id=9dc9b764&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc9b764"]])

export default __exports__